import { render, staticRenderFns } from "./BaoRecord.vue?vue&type=template&id=62fcdfb0&scoped=true&"
import script from "./BaoRecord.vue?vue&type=script&lang=js&"
export * from "./BaoRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fcdfb0",
  null
  
)

export default component.exports